import { Formik } from 'formik';

import { Messages } from 'config';
import { ButtonColors } from 'types';
import { formatPrice } from 'utils/helpers';
import { isMobile, useAlert, handleMutation } from 'hooks';
import { useApproveCartProductsMutation } from 'store/api/price-approval';
import {
  Col,
  Row,
  Flex,
  Dialog,
  Button,
  DialogType,
  InputField,
  ButtonTypes,
  CommonStyles,
} from 'components';

import { initialValues, validationSchema } from './config';
import { FormValues, ApprovalRequestDialogProps } from './types';

export const ApprovalRequestDialog = ({
  open,
  cart,
  event,
  onClose,
  onSuccess,
  isFromShipping,
  totalMinPriceProducts,
  totalCartPriceProducts,
}: ApprovalRequestDialogProps) => {
  const mobile = isMobile();
  const { showSuccessAlert } = useAlert();

  const [createApproval, mutation] = useApproveCartProductsMutation();
  handleMutation(mutation);

  return (
    <Dialog
      open={open}
      showCloseButton
      onClose={onClose}
      title="Approval request"
      width={mobile ? '90vw' : '600px'}
    >
      {(close, _, ButtonWrap) => (
        <Formik<FormValues>
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            const approval = await createApproval({
              isFromShipping,
              cartId: Number(cart?.id),
              eventId: Number(event?.id),
              approvalPassword: values.approvalPassword,
            }).unwrap();

            if (approval) {
              showSuccessAlert(
                `Approval request ${Messages.CREATED_SUCCESSFULLY}`
              );
              close();
              onSuccess?.();
            }
          }}
        >
          {({ dirty, isSubmitting }) => (
            <CommonStyles.Form autoComplete="off">
              <Flex gap={24} flexDirection="column">
                <p>
                  Manager confirmation is required to complete the order because
                  the total cart amount{' '}
                  <span className="semibold">
                    ({formatPrice(totalCartPriceProducts)})
                  </span>{' '}
                  is below the minimum required amount (
                  <span className="semibold">
                    {formatPrice(totalMinPriceProducts)}
                  </span>
                  ).
                </p>

                <Row>
                  <Col>
                    <InputField
                      number
                      autofill="off"
                      label="Manager PIN"
                      name="approvalPassword"
                      placeholder="Manager PIN"
                      autoComplete="one-time-code"
                    />
                  </Col>
                </Row>

                <ButtonWrap type={DialogType.Plain}>
                  <Button
                    text="Cancel"
                    onClick={close}
                    colorType={ButtonColors.LightBlue}
                  />
                  <Button
                    text="Approve"
                    type={ButtonTypes.Submit}
                    disabled={!dirty || isSubmitting}
                  />
                </ButtonWrap>
              </Flex>
            </CommonStyles.Form>
          )}
        </Formik>
      )}
    </Dialog>
  );
};
